import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const OverlayActionButtonWidget: WidgetRegistryEntry = {
  name: "OverlayActionButton",
  configuration: () => import("./configuration").then((m) => m.OverlayActionButtonWidgetConfiguration),
  component: () => import("./overlay-action-button-widget.component").then((m) => m.OverlayActionButtonWidgetComponent)
};
